import React from 'react';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Input,
  Grid,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

const FertilizerDetails = ({ state, setState }) => {
  const handleChange = (field) => (value) => {
    console.log('Handle Change: ', field)
    console.log('value', value)
    setState({
      ...state,
      fertilizerDetails: {
        ...state.fertilizerDetails,
        [field]: value
      }
    });
  };

  const handleArrayChange = (field) => (event, newValue) => {
    setState({
      ...state,
      fertilizerDetails: {
        ...state.fertilizerDetails,
        [field]: newValue
      }
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="NPK Ratio"
          value={state.fertilizerDetails?.npkRatio || ''}
          onChange={e => handleChange('npkRatio')(e.target.value)}
          helperText="e.g., 10-10-10, 20-20-20"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel id="fertilizer-type-label">Fertilizer Type</InputLabel>
          <Select
            labelId="fertilizer-type-label"
            value={state.fertilizerDetails?.fertilizerType || ''}
            onChange={e => handleChange('fertilizerType')(e.target.value)}
            label="Fertilizer Type"
          >
            {['Granular', 'Liquid', 'Slow-Release', 'Quick-Release', 'Organic', 'Synthetic', 'Water-Soluble'].map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          options={[]}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Primary Nutrients"
              placeholder="Add primary nutrients"
              helperText={`Press Enter When Finished Typing (e.g., Nitrogen, Phosphorus, Potassium)`}
            />
          )}
          value={state.fertilizerDetails?.primaryNutrients || []}
          onChange={handleArrayChange('primaryNutrients')}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          options={[]}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Secondary/Micronutrients"
              placeholder="Add secondary nutrients"
              helperText={`Press Enter When Finished Typing (e.g., Calcium, Magnesium, Iron)`}
            />
          )}
          value={state.fertilizerDetails?.secondaryNutrients || []}
          onChange={handleArrayChange('secondaryNutrients')}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          options={[]}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Target Plants/Crops"
              placeholder="Add target plants"
              helperText={`Press Enter When Finished Typing`}
            />
          )}
          value={state.fertilizerDetails?.targetPlants || []}
          onChange={handleArrayChange('targetPlants')}
        />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          options={[]}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Application Methods"
              placeholder="Add application methods"
              helperText={`Press Enter When Finished Typing (e.g., Broadcast, Foliar, Drip)`}
            />
          )}
          value={state.fertilizerDetails?.applicationMethod || []}
          onChange={handleArrayChange('applicationMethod')}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Application Rate"
          value={state.fertilizerDetails?.applicationRate || ''}
          onChange={e => handleChange('applicationRate')(e.target.value)}
          helperText="e.g., 1 lb per 1000 sq ft"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Coverage Area"
          value={state.fertilizerDetails?.coverageArea || ''}
          onChange={e => handleChange('coverageArea')(e.target.value)}
          helperText="e.g., 5000 sq ft per bag"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Manufacturer"
          value={state.fertilizerDetails?.manufacturer || ''}
          onChange={e => handleChange('manufacturer')(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          label="Product Code/SKU"
          value={state.fertilizerDetails?.productCode || ''}
          onChange={e => handleChange('productCode')(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="Safety Precautions"
          multiline
          rows={3}
          value={state.fertilizerDetails?.safetyPrecautions || ''}
          onChange={e => handleChange('safetyPrecautions')(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="Storage Instructions"
          multiline
          rows={2}
          value={state.fertilizerDetails?.storageInstructions || ''}
          onChange={e => handleChange('storageInstructions')(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="SDS/MSDS URL"
          value={state.fertilizerDetails?.msds_url || ''}
          onChange={e => handleChange('msds_url')(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          label="Product Label URL"
          value={state.fertilizerDetails?.label_url || ''}
          onChange={e => handleChange('label_url')(e.target.value)}
        />
      </Grid>
    </Grid>
  );
};

export default FertilizerDetails;
